const globalConfig = {
  // //新闻接口地址
  // mainApi: 'https://www.hdzkcm.com/gwnews_service/',
  // //素材文件地址
  // filePath: 'http://99.99.99.22:5000/xxgc/',
  // //OA文件地址
  // OAFilePath: 'https://imagedownload.guanweinet.com:9999',
  // //学校ID
  // schoolId: '201807009'

  //新闻接口地址
  mainApi: 'https://www.kjxxgc.com/gwnews_service/',
  //素材文件地址
  filePath: 'https://www.kjxxgc.com/filePath/',
  //OA文件地址
  //OAFilePath: 'https://imagedownload.guanweinet.com:9999',
  OAFilePath: 'https://www.kjxxgc.com/fileImage',
  //学校ID
  schoolId: '201807002'
}
module.exports = globalConfig;



// WEBPACK FOOTER //
// ./src/plugin/config.js